<template>
	<div :class="[{ icon: true, byHeight: iconInfo.byHeight }, classesProcessed]" @click="clicked" v-if="iconInfo">
		<img :src="iconInfo.src" class="svg" v-if="iconInfo.type === 'img'" />
		<font-awesome-icon :icon="iconInfo.icon" v-if="iconInfo.type === 'fa'" :style="styleProcessed" />
		<svg
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			:viewBox="iconInfo.viewBox"
			xml:space="preserve"
			v-if="iconInfo.type === 'svg'"
			v-html="iconInfo.src"></svg>
		<span class="title" :class="{ 'title-left': titleLeft }" v-if="titleFancy"
			><span class="title-text" v-html="titleFancy" :style="titleStyle"></span
		></span>
	</div>
</template>

<script>
import { computed } from "vue";
export default {
	name: "BaseIcon",
	props: {
		type: {
			type: String,
			required: true,
		},
		colour: {
			type: String,
			default: "#a26c67",
		},
		classes: {
			type: Object,
			default: () => ({}),
		},
		titleFancy: {
			type: String,
			default: "",
		},
		titleLeft: {
			type: Boolean,
			default: false,
		},
		hasClicked: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const titleStyle = computed(() => {
			let s = {};
			s.backgroundColor = props.colour;
			s.border = "1px solid #fff";
			s.color = "#fff";
			return s;
		});

		const iconType = computed(() => {
			switch (props.type) {
				case "social-following":
					return "user-plus";
				case "popular_now":
					return "fire";
				case "top-responder":
				case "top_responder":
				case "credibility":
					return "medal";
				case "brand-awareness":
					return "bullhorn";
				case "social-engagement": // Increase social engagement
					return "heart";
				case "engage-audience": // Engage with audience
					return "comments";
				case "boost-sales": // Boost sales
				case "credits":
					return "coins";
				case "reviews": // Increase product reviews
					return "star";
				case "delight": // Surprise and delight customers
					return "gift";
				case "product-hands": // Get product into hands
					return "hand-holding-heart";
				case "visibility": // SEO and brand visibility
					return "magnifying-glass-plus";
				case "newsletter": // Grow newsletter subscribers
					return "envelope-open-text";
				case "new-customers": // New customers
					return "people-group";
				case "alerts":
				case "alert":
					return "bell";
				case "users":
					return "cog";
				case "admin":
					return "tools";
				case "show-menu":
					return "exchange-alt";
				case "email":
					return "envelope";
				case "phone":
					return "phone";
				case "vegan":
					return "leaf";
				case "connections":
					return "square-check";
				case "requests":
					return "envelope-open-text";
				case "matches":
					return "people-group";
				case "pin":
					return "map-pin";
				case "dashboard":
					return "house";
				case "profile":
					return "circle-user";
				case "ideas":
					return "bulb2";
				case "sent":
					return "fa-right-from-bracket";
				case "received":
					return "fa-right-to-bracket";
				case "cart":
					return "cart-shopping";
				case "calendar":
					return "fa-calendar";
				case "doi":
					return "fa-calendar";
				case "sign-out":
					return "sign-out-alt";
				case "subscriptions":
					return "dollar-sign";
				case "snooze":
					return "snooze";
				case "declines":
					return "x";
				case "website":
					return "globe";
				case "arrow-left":
					return "left-long";
				case "arrow-right":
					return "right-long";
				case "pitch":
					return "seedling";
				case "help":
					return "circle-question";
				case "upload":
					return "arrow-up-from-bracket";
				case "id":
					return "id-card";
				case "thumbs-down":
					return "thumbs-down";
			}
			return props.type;
		});

		const iconInfo = computed(() => {
			let img = { type: "", src: "", byHeight: false };
			switch (iconType.value) {
				case "square-check":
				case "icons":
				case "puzzle-piece":
				case "leaf":
				case "exchange-alt":
				case "envelope":
				case "envelope-open-text":
				case "paper-plane":
				case "map-pin":
				case "phone":
				case "star":
				case "house":
				case "person":
				case "circle-user":
				case "lightbulb":
				case "fa-right-to-bracket":
				case "fa-right-from-bracket":
				case "fa-circle-check":
				case "fa-circle-xmark":
				case "user-plus":
				case "bullhorn":
				case "seedling":
				case "medal":
				case "heart":
				case "comments":
				case "coins":
				case "gift":
				case "hand-holding-heart":
				case "magnifying-glass-plus":
				case "people-group":
				case "bookmark":
				case "sign-out-alt":
				case "dollar-sign":
				case "globe":
				case "left-long":
				case "right-long":
				case "ban":
				case "arrow-up-from-bracket":
				case "fire":
				case "id-card":
					img.type = "fa";
					img.icon = iconType.value;
					break;
				case "circle-question":
					img.type = "fa";
					img.icon = ["fas", "circle-question"];
					break;
				case "thumbs-up":
					img.type = "svg";
					img.src =
						'<path style="fill:' +
						props.colour +
						';" d="M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z" />';
					img.viewBox = "0 0 512 512";
					break;
				case "thumbs-down":
					img.type = "svg";
					img.src =
						'<path style="fill:' +
						props.colour +
						';" d="M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8l97.5 0c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 320c-17.7 0-32-14.3-32-32L0 64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z" />';
					img.viewBox = "0 0 512 512";
					break;
				case "crown":
					img.type = "svg";
					img.src =
						'<path style="fill:' +
						props.colour +
						';stroke-width:0px;" d="M372.2,52c0,20.9-12.4,39-30.2,47.2l106,92.8,102.2-20.4,2.2-.4c-5.3-7.7-8.4-17.1-8.4-27.1,0-26.5,21.5-48,48-48s48,21.5,48,48-20.6,47.1-46.4,48l-9.8,21.8-102.8,228.4c-10.3,23-33.2,37.7-58.4,37.7h-205.2c-25.2,0-48-14.8-58.4-37.7L56.2,213.8l-9.8-21.8c-25.8-.9-46.4-22-46.4-48s21.5-48,48-48,48,21.5,48,48c0,10.1-3.1,19.4-8.4,27.1l2.2.4,102.2,20.5,106.1-92.9c-17.7-8.3-30-26.3-30-47.1C268.1,23.3,291.4,0,320.1,0s52,23.3,52,52h.1ZM416.4,228.1l-96.4-84.3-96.4,84.3c-11.2,9.8-26.4,13.9-41,10.9l-68.6-13.6,88.7,197.2c2.6,5.7,8.3,9.4,14.6,9.4h205.2c6.3,0,12-3.7,14.6-9.4l88.9-197.2-68.5,13.7c-14.6,2.9-29.8-1.1-41-10.9l-.1-.1Z" />';
					img.viewBox = "0 0 640 480";
					break;
				case "x":
					img.type = "fa";
					img.icon = "rectangle-xmark";
					break;
				case "fa-calendar":
					img.type = "fa";
					img.icon = "fa-calendar";
					break;
				case "cart-shopping":
					img.type = "fa";
					img.icon = ["fas", "shopping-cart"];
					img.icon = "fa-shopping-cart";
					break;
				case "bell":
					img.type = "fa";
					img.icon = "bell";
					break;
				case "facebook":
					img.type = "fa";
					img.icon = "fa-brands fa-facebook-f";
					break;
				case "twitter":
					img.type = "fa";
					img.icon = "fa-brands fa-x-twitter";
					break;
				case "tiktok":
					img.type = "fa";
					img.icon = "fa-brands fa-tiktok";
					break;
				case "linkedin":
					img.type = "fa";
					img.icon = "fa-brands fa-linkedin";
					break;
				case "instagram":
					img.type = "fa";
					img.icon = "fa-brands fa-instagram";
					break;
				case "at":
					img.type = "fa";
					img.icon = "fa-at";
					break;
				case "tools":
					img.type = "fa";
					img.icon = "tools";
					break;
				case "cog":
					img.type = "fa";
					img.icon = "users-cog";
					break;
				case "projects":
				case "project-diagram":
					img.type = "fa";
					img.icon = "project-diagram";
					break;
				case "paper-plane":
					img.type = "fa";
					img.icon = "paper-plane";
					break;
				case "mag":
					img.type = "img";
					img.src = require("../../assets/img/mag-glass-key.svg");
					break;
				case "snooze":
					img.type = "svg";
					img.src =
						'<path style="stroke-width:0px;stroke:' +
						props.colour +
						';stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;fill:none;" d="M-3.09-2.74h24v24H-3.09V-2.74Z"/><path style="stroke:' +
						props.colour +
						';stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;fill:none;" d="M1.91,10.26c0,3.87,3.13,7,7,7s7-3.13,7-7-3.13-7-7-7S1.91,6.39,1.91,10.26"/><path style="stroke:' +
						props.colour +
						';stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;fill:none;" class="cls-2" d="M6.91,8.26h4l-4,4h4"/><path style="stroke:' +
						props.colour +
						';stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;fill:none;" class="cls-2" d="M3.91,1.26L1.16,3.26"/><path style="stroke:' +
						props.colour +
						';stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;fill:none;" class="cls-2" d="M13.91,1.26l2.75,2"/>';
					img.viewBox = "0 0 17.9 18.45";
					break;
				case "bulb2":
					img.type = "img";
					img.src = require("../../assets/img/bulb2.svg");
					break;
				case "matches":
				case "connections":
				case "requests":
					img.type = "img";
					img.src = require("../../assets/img/" + iconType.value + ".svg");
					break;
				case "graph":
					img.type = "img";
					img.src = require("../../assets/img/graph.svg");
					break;
				case "ring-spin":
					img.type = "img";
					img.src = require("../../assets/img/ring-spin.svg");
					break;
				case "bolt":
					img.type = "fa";
					img.icon = "bolt";
					img.byHeight = true;
					break;
				case "bulb":
					img.type = "img";
					if (props.colour === "#ffffff") {
						img.src = require("../../assets/img/bulb-white.svg");
					} else {
						img.src = require("../../assets/img/bulb.svg");
					}
					break;
				case "search":
					img.type = "fa";
					img.icon = "search";
					break;
				case "handshake":
					img.type = "fa";
					img.icon = "handshake";
					break;
				case "video-youtube":
					img.type = "svg";
					img.src =
						'<path style="fill:' +
						props.colour +
						';" class="st" d="M99.72,6.1H19.38c-7.23,0-13.11,5.88-13.11,13.11v56.74c0,7.23,5.88,13.11,13.11,13.11h80.33c7.23,0,13.11-5.88,13.11-13.11V19.21C112.82,11.98,106.94,6.1,99.72,6.1z M47.64,63.46V31.69l25.74,15.89L47.64,63.46z"/>';
					img.viewBox = "0 0 117.1 95.15";
					break;
				case "writing-tool":
					img.type = "svg";
					img.src =
						'<g class="writing-tool-icon" fill="none" stroke="' +
						props.colour +
						'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
						'<path class="writing-tool-icon__path writing-tool-icon__path--one" d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>' +
						'<path class="writing-tool-icon__path writing-tool-icon__path--two" d="M20 2v4"></path>' +
						'<path class="writing-tool-icon__path writing-tool-icon__path--three" d="M22 4h-4"></path>' +
						'<circle cx="4" cy="20" r="2"></circle>' +
						"</g>";
					img.viewBox = "0 0 24 24";
					break;
			}
			if (!img.type) {
				try {
					img.type = "svg";
					img.src = require("../../assets/img/icon-" + iconType.value + ".svg");
				} catch (e) {
					return "";
				}
			}
			return img;
		});

		const classesProcessed = computed(() => {
			let c = props.classes || {};
			c[iconType.value] = true;
			c[props.type] = true;
			return c;
		});

		const styleProcessed = computed(() => {
			let s = {};
			if (!props.classes || !props.classes.colour) {
				s.color = props.colour;
				s.fill = props.colour;
			}
			return s;
		});

		const clicked = (e) => {
			if (props.hasClicked) {
				e.stopPropagation();
			}
			emit("clicked");
		};

		return {
			titleStyle,
			iconInfo,
			classesProcessed,
			styleProcessed,
			clicked,
		};
	},
};
</script>
<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
.icon {
	width: 100%;
	display: inline-block;
	vertical-align: middle;
	position: relative;

	.title {
		position: absolute;
		top: 0;
		left: 100%;
		display: none;
		font-size: 12px;
		z-index: 10;
		padding: 0 0 0 10%;

		.title-text {
			display: inline-block;
			padding: 2px 5px;
			white-space: pre;
			border-radius: @radiusXs;
		}

		&.title-left {
			left: auto;
			right: 100%;
			padding: 0 10% 0 0;
		}
	}

	&:hover {
		.title {
			display: block;
		}
	}

	svg,
	.svg {
		width: 100%;
		height: 100%;
		display: block;
	}

	&.received {
		svg,
		.svg {
			transform: rotate(180deg);
		}
	}

	&.writing-tool {
		opacity: 0.8;
		transform: rotate(15deg);

		&.no-opacity {
			opacity: 1;
		}

		&.writing-tool-animated {
			:deep(.writing-tool-icon__path) {
				transform-box: fill-box;
				transform-origin: center;
				animation-duration: 10s;
				animation-iteration-count: infinite;
				animation-timing-function: ease-in-out;
			}

			:deep(.writing-tool-icon__path--one) {
				animation-name: writing-tool-path-one;
			}

			:deep(.writing-tool-icon__path--two) {
				animation-name: writing-tool-path-two;
			}

			:deep(.writing-tool-icon__path--three) {
				animation-name: writing-tool-path-three;
			}
		}
	}

	&.colour {
		&.default-white-hover {
			svg,
			.svg {
				color: @formDefaultColour;

				&:hover {
					color: #fff;
				}
			}
		}
	}
}

@keyframes writing-tool-path-one {
	0%,
	8%,
	100% {
		opacity: 0.8;
		stroke-width: 2;
		transform: scale(1);
	}
	10%,
	14% {
		opacity: 1;
		stroke-width: 2.4;
		transform: scale(1.08);
	}
	18% {
		opacity: 0.8;
		stroke-width: 2;
		transform: scale(1);
	}
}

@keyframes writing-tool-path-two {
	0%,
	16%,
	100% {
		opacity: 0.75;
		stroke-width: 2;
		transform: translateY(0);
	}
	19%,
	24% {
		opacity: 1;
		stroke-width: 2.3;
		transform: translateY(-1px);
	}
	28% {
		opacity: 0.75;
		stroke-width: 2;
		transform: translateY(0);
	}
}

@keyframes writing-tool-path-three {
	0%,
	24%,
	100% {
		opacity: 0.7;
		stroke-width: 2;
		transform: scale(1) rotate(0deg);
	}
	27%,
	32% {
		opacity: 1;
		stroke-width: 2.4;
		transform: scale(1.1) rotate(-8deg);
	}
	36% {
		opacity: 0.7;
		stroke-width: 2;
		transform: scale(1) rotate(0deg);
	}
}

@media (prefers-reduced-motion: reduce) {
	.icon.writing-tool.writing-tool-animated {
		:deep(.writing-tool-icon__path) {
			animation: none;
		}
	}
}
</style>
